<template>
  <div>
    <footer id="footer">
      <div class="inner">
        <div class="left">
          <h1 class="foot-logo"><a href="/" title="to home"><img src="../resource/images/foot_logo.png" alt="애드매스"></a></h1>
          <p>Copyright ⓒ 애드매스 All rights reserved.</p>
        </div>
        <div class="right">
          <a href="http://pf.kakao.com/_dekCs" target="_blank" class="btn-kakao"><img src="../resource/images/btn_kakao.png" alt="카카오 이동"></a>
          <ul class="foot-info">
            <li>상호: 애드매스</li>
            <li>주소: 서울특별시 금천구 가산디지털1로 142 스카이밸리1차 5층 516호</li>
            <li>사업자등록번호: 496-17-00820 ㅣ 전화: 02-2067-1213</li>
          </ul>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>

export default {
  name: 'common-footer',
  components: {

  },
  mounted() {
  }
}

</script>